export default "__VITE_ASSET__DYgRawym__"